// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24bK2","field":"styles_field__YYESx","fieldCol":"styles_fieldCol__2zEiJ","diffCol":"styles_diffCol__lV9r5","diff":"styles_diff__QpkFD"};